export const tableHeader = [
    { title: 'Date & Network', key: '1' },
    { title: 'Type', key: '2' },
    { title: 'Timing End', key: '3' },
    { title: 'Name & Total Value', key: '4' },
    { title: 'Heir Address', key: '5' },
    { title: 'Transaction Id', key: '6' },
];

export const columns = [
    { title: 'Tokens', key: 'Tokens' },
    { title: 'Amount', key: 'Amount' },
    { title: 'Amount Allocated', key: 'Amount Allocated' },
    { title: 'Percentage Allocated', key: 'Percentage Allocated' },
    { title: 'Token Id', key: 'Token Id' },
    { title: 'Flash Audit', key: 'Flash Audit' },
];
